import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--ldr-bg-alt)]">
        <div className="text-[var(--ldr-text-muted)] text-sm" data-testid="auth-checking">
          A verificar sessão…
        </div>
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return children;
}
